// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3ttF9","title":"Info_title__3xM1Q","selects":"Info_selects__1XQgB","requiredAsterisk":"Info_requiredAsterisk__uCjH4"};